import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row border rounded pt-6 pb-8" }
const _hoisted_4 = { class: "col-lg-9 mt-6 px-10" }
const _hoisted_5 = { class: "fw-bolder report-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/svg/files/spinner.svg",
  alt: ""
}, null, -1)
const _hoisted_7 = { class: "px-2" }
const _hoisted_8 = { class: "pt-4 report-text" }
const _hoisted_9 = { class: "pt-6 report-sub-text" }
const _hoisted_10 = { class: "pt-6" }
const _hoisted_11 = {
  href: "tel:+18446277246",
  class: "btn-call"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/svg/files/phone.svg",
  alt: ""
}, null, -1)
const _hoisted_13 = { class: "px-2" }
const _hoisted_14 = { class: "col-lg-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", { src: "/media/img/report-view.png" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("We are processing your report")), 1)
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(
                "Our patient relations coordinator will contact you to give you more information and answer any questions you have."
              )), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("You can contact us any time at the number below.")), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("MassiveBioPhoneNumberLabel")), 1)
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_14, _hoisted_16, 512), [
          [_vShow, !_ctx.ismobile]
        ])
      ])
    ])
  ]))
}